export default "__VITE_ASSET__qjghTK46__"